var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "container-fluid bg-accent d-flex flex-column align-items-center justify-content-center px-32 px-lg-12 text-center"
      },
      [
        _c("h2", { staticClass: "text-white mb-32" }, [
          _vm._v(_vm._s(_vm.text))
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              staticClass: "btn btn-white",
              attrs: { href: _vm.dayConfigurator }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.hasTemplateUrl
                      ? "Stel deze dag samen"
                      : "Stel zelf je dag samen"
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }